import { createSelector } from 'reselect';
import Resdit7421PerformanceLocationColumns from '../../containers/Resdit7421PerformanceLocationColumns';
import Resdit7421PerformanceLocationData from '../../containers/Resdit7421PerformanceLocationData';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import { getPropertyValueByPath } from "../../../../../../react-table/helpers/utils";
import { getReportState, getReportMode } from "../../../../../common/redux/selectors/ReportsSelectors";

export const COLUMN_ACCESSOR_CARDIT_TOTALS = 'cardit.totals';

export const HEADER_CARDIT = 'cardit';
export const HEADER_RESDIT = 'resdit';

export const COLUMN_LEAF_EXCLUSIONS = ['cardit.carrier'];

export const PROPERTY_ORIGINAL_GRAND_TOTAL = 'originalGrandTotal';
export const PROPERTY_ORIGINAL_GROUP_TOTAL = 'originalGroupTotal';

export const getGeneratedOnDateTime = state => state
  .reporting.RESDIT_74_21_PERFORMANCE_LOCATION_107B.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_107B.isLoading;

export const getIsFiltered = state => state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_107B.filtering &&
  state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_107B.filtering.appliedFilters &&
  state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_107B.filtering.appliedFilters.some(filter => !filter.value.clearFilter);

export const getData =
  ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.getDataFunction();

export const getOriginalGrandTotal = state => state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_107B.data
  .map(row => getPropertyValueByPath(row, COLUMN_ACCESSOR_CARDIT_TOTALS)[0])
  .reduce((grandTotal, groupTotal) => grandTotal + groupTotal, 0);

export const getColumns =
  createSelector(
    getData,
    state => state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_107B.requestParams,
    state => getReportMode(state, ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id),
    Resdit7421PerformanceLocationColumns,
  );

export const getFilteredAndSortedData =
  createSelector(
    state => getReportState(state, ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id),
    getColumns,
    Resdit7421PerformanceLocationData,
  );
